import { 
  CTA_TYPE, 
  getTripTypeForHOB, 
  pushOmniEvents 
}                       from "../utils/omni-utils"
import dateFormat       from 'dateformat'
import { 
  dateTypeFormat, 
  LOCAL_RENTAL, 
  ROUND_TRIP,
  RouteCountry,
  timeTypeFormat
}                       from "../utils/util-constants"
import { LoyaltyInfo }  from "../pages/Homepage/redux/types"

const homeSection             : string  = "landing"
const funnelSection           : string  = "domestic cabs funnel"
const homePageType            : string  = homeSection
const funnelPageType          : string  = "funnel"
const seoPageType             : string  = "seo"
const seoRoutePageType        : string  = "seo_route"
const platform                : string  = "DWEB"
const mwebPlatform            : string  = "MWEB"
const siteName                : string  = "GI"
const directCabsFlow          : string  = "direct-cabs"
const seoCabsFlow             : string  = seoPageType
const homePageName            : string  = "landing:domestic cabs:landing"
const tripCategoryPageName    : string  = "funnel:domestic cabs:listing"   //srp
const bookingReviewPageName   : string  = "funnel:domestic cabs:review"   //review
const hobLandingPageName      : string  = "landing:domestic cabs:landing:hobprovisonal"  
const hobListingPageName      : string  = "landing:domestic cabs:listing:hobprovisonal"  
const hobThankYouPageName     : string  = "landing:domestic cabs:thankyou:hobprovisonal"  

export const gcRentalSEOScreen      : string  = 'goCarsRentalSEOScreen'
export const gcAirportCitySEOScreen : string  = "goCarsAirportCitySEOScreen"
export const gcRouteSEOScreen       : string  = "goCarsRouteSEOScreen"
export const gcCitySEOScreen        : string  = "goCarsCitySEOScreen"
export const lob                    : string  = "domestic cabs"
export const gcHomeScreen           : string  = "goCarsHomeScreen"
export const gcTripCategoryScreen   : string  = "goCarsTripCategoryScreen"
export const gcBookingReviewScreen  : string  = "goCarsBookingReviewScreen"
export const gcHobLandingScreen     : string  = "goCarsHobLandingScreen"
export const gcHobListingScreen     : string  = "goCarsHobListingScreen"
export const gcHobThankyouScreen    : string  = "goCarsHobThankyouScreen"

let loadedComponent : string = ""
interface AccountInfo {
  accountInfo : {
    custID        : string
    loginStatus   : string
    goCash        : string
    hydraSegment  : string
    loyaltyStatus : string
  }
}

interface PageInfo {
  pageInfo : {
    section           : string
    pageName          : string
    pageType          : string
    lob               : string
    siteName          : string
    platform          : string
    flow              : string
    loadedComponents ?: string
    abVariant       ?: string
  }
}

export interface ErrorInfo {
  field   : string
  message : string
}

interface ErrorOmni {
  errorInfo : string
}

export const getLoadedComponent = (componentName : string)  => {
  if (loadedComponent.length) {
    loadedComponent += loadedComponent.includes(componentName) ? '' : ` | ${componentName}`
  } else {
    loadedComponent = componentName
  }
}

export const sendEventOnError = (error : ErrorInfo[]) => {
  const eventName     : string      = "error"
  const errorDetails  : ErrorOmni[] = []

  error.map(err => {
    if (err) {
      const obj : ErrorOmni = {
        errorInfo : `${err?.field} | ${err?.message}`
      }
      errorDetails.push(obj)
    }
  })

  const eventDetails = {
    error : errorDetails
  }

  pushOmniEvents({eventName, details : eventDetails})
}

export const getCtaProperty = (name : string, type : CTA_TYPE, componentName : string, destination : string) => {
  const cta = {
    name          : name,
    type          : type,
    componentName : componentName,
    destination   : destination 
  }

  return cta
}

export const pushCtaOmniEvents = (name : string, type : CTA_TYPE, componentName : string, destination : string) => {
  const eventDetails = {
    cta : getCtaProperty(name, type, componentName, destination)
  }

  pushOmniEvents({eventName: "ctaClick", details: eventDetails})
}

export const getTripDays = (startDate : string, endDate : string, isNumReq = false, isMulticityText = false) : string | Number => {
  if (!startDate && !endDate) return ''
  if(isMulticityText){
    // Extract only dates from the date-time string
    const start = new Date(new Date(startDate).toISOString().split('T')[0])
    const end = new Date(new Date(endDate).toISOString().split('T')[0]);
    // Calculate the difference in hours
    const diffInHours = (end.getTime() - start.getTime()) / (1000 * 60 * 60);
    // Calculate the number of days
    const days = diffInHours === 0 ? 1 : diffInHours / 24 + 1;
    return isNumReq ? days : `${days}`;
  }else{
    const dateDiff : number = +new Date(endDate).getTime() - +new Date(startDate).getTime()
    return isNumReq ? Math.round(dateDiff/(1000*60*60*24)) : `${Math.round(dateDiff/(1000*60*60*24))}`
  }
}

export const get24HoursTime = (time : string) : string => {
  let realTime : string = ''
  if (time.toLowerCase().includes('pm')) {
    const newTime : string = time.replace(' PM', '')
    const hours : string = newTime.split(':')[0]
    const mins : string = newTime.split(':')[1]
    realTime = `${+hours + 12}:${mins}`
  } else if (time.toLowerCase().includes('am')) {
    const newTime : string = time.replace(' AM', '')
    realTime = `${newTime}`
  } else {
    realTime = time
  }

  return realTime
}

export const getRouteDetails = (sourceVal : string, destinationVal : string) => {
  let route
  if (sourceVal && destinationVal) {
    route = `${sourceVal}-${destinationVal}`
  } else if (sourceVal && !destinationVal) {
    route = `${sourceVal}`
  } else if (!sourceVal && destinationVal) {
    route = `${destinationVal}`
  } else {
    route = ''
  }

  return route
}

export const pageViewOmniEvent = (
  store       : any     = {},
  screenName  : string  = gcHomeScreen
) => {
    const { home = {}, common = {}, review = {}, srp = {}, seoPage = {}, hob = {} } = store
    const { tripType = {}, flow } = common
    const { results = {} } = srp
    const { common_data = {}, vehicle_data = [] } = results
    const { hobListingResponse = {}, hobThankYouResponse = {}} = hob
    const {
      dispatch_search_id  = "",
      package_id          = "",
      source_city         = "",
      destination_city    = "",
      source              = {},
      destination         = {}
    } = common_data;
    const { reviewResults = {}} = review
    const { booking_tags = []}  = reviewResults
    const { name = ""}          = tripType

    let eventDetails  : any           = {}
    let hydraSegments : string        = ""
    const eventName   : string        = "pageView"
    const custId      : string        = home?.uuid || ""
    const goCashAmnt  : string        = home?.gocash_bal || "0"
    const loyalty     : LoyaltyInfo   = home?.loyalty_info || null

    if (home?.hydraSegments && Object.keys(home?.hydraSegments)?.length) {
      for (let key in home?.hydraSegments) {
        hydraSegments += hydraSegments?.length ? `|${key}` : key
      }
    }
    
    const getAccountInfo = () : AccountInfo => {
      const accountInfo : AccountInfo = {
        accountInfo : {
          custID        : custId,
          loginStatus   : `${custId?.length ? "Logged-In" : "Guest"}`,
          goCash        : goCashAmnt,
          hydraSegment  : hydraSegments,
          loyaltyStatus : loyalty?.tierNumber && loyalty?.status  ? `Tier${loyalty?.tierNumber}_${loyalty?.status}` : ""
        }
      }
      
      return accountInfo
    }

    const getPageInfo = (details : {section : string, pageName : string, pageType : string, flow : string, isSeoPage : boolean, loadedComponents ?: string, ab_variant?:string}) : PageInfo => {
      const pageDetails : PageInfo = {
        pageInfo : {
          section: details?.section,
          pageName: details?.pageName,
          pageType: details?.pageType,
          siteName: `${siteName}`,
          platform: `${details?.pageName === hobLandingPageName || details?.pageName === hobListingPageName || details?.pageName === hobThankYouPageName ? mwebPlatform : platform}`,
          flow: details?.flow || (details?.isSeoPage ? seoCabsFlow : directCabsFlow),
          lob,
          abVariant: details?.ab_variant || ""
        }
      }

      if (details?.loadedComponents) {
        pageDetails.pageInfo['loadedComponents'] = details?.loadedComponents
      }

      return pageDetails
    }

    switch (screenName) {
      case gcHomeScreen:
        eventDetails = {
          page    : getPageInfo({section: homeSection,pageName: homePageName, pageType: homePageType, flow, isSeoPage: false, loadedComponents : loadedComponent || ""}),
          account : getAccountInfo()
        }
        break;
      case gcTripCategoryScreen:
        eventDetails = {
          search  : {
            searchId                : dispatch_search_id,
            noOfSearchResults       : vehicle_data?.length,  
            alternateDateTimePopup  : Object.keys(common_data)?.length && common_data?.popup && Object.keys(common_data?.popup)?.length ? "yes" : "no" 
          },
          booking: {
            tripType                : name,
            routeCity               : getRouteDetails(source_city, destination_city).length ? getRouteDetails(source_city, name === LOCAL_RENTAL ? '' : destination_city) : getRouteDetails(common?.source?.name, name === LOCAL_RENTAL ? '' : common?.destination?.name),
            routeState              : getRouteDetails(source?.State, destination?.State).length ? getRouteDetails(source?.State, name === LOCAL_RENTAL ? '' : destination?.State) : getRouteDetails(common?.source?.state, name === LOCAL_RENTAL ? '' : common?.destination?.state),
            routeCountry            : RouteCountry,
            departureDate           : `${dateFormat(common?.startDate?.date, dateTypeFormat)}`,
            departureTime           : `${get24HoursTime(common?.startDate?.time)}`,
            cabsIsPrivateAvailable  : vehicle_data?.length ? "yes" : "no",
            daysToTrip              : getTripDays(new Date().toString(), common?.startDate?.date)
          },
          page    : getPageInfo({section: funnelSection, pageName: tripCategoryPageName, pageType: funnelPageType, flow, isSeoPage: false, loadedComponents : loadedComponent || "", ab_variant: common_data?.ab_variant}),
          account : getAccountInfo()
        }
        break;
      case gcBookingReviewScreen:
        let bookingTags = ""
        const skuDetails = `${reviewResults?.category} | ${reviewResults?.t} ${reviewResults?.st} | fuelType : ${reviewResults?.fuel?.t}`
        if (booking_tags?.length) {
          booking_tags.forEach(tag => {
            bookingTags += bookingTags.length ? `| ${tag}` : `${tag} `
          })
        }
        eventDetails = { 
          productListItems: [{
              SKU : skuDetails
          }],
          booking: {
            tripType                : name,
            routeCity               : getRouteDetails(reviewResults?.source_city, reviewResults?.destination_city).length ? getRouteDetails(reviewResults?.source_city, name === LOCAL_RENTAL ? '' : reviewResults?.destination_city) : getRouteDetails(common?.source?.name, name === LOCAL_RENTAL ? '' : common?.destination?.name),
            routeState              : getRouteDetails(reviewResults?.source_state, reviewResults?.destination_state).length ? getRouteDetails(reviewResults?.source_state, name === LOCAL_RENTAL ? '' : reviewResults?.destination_state) : getRouteDetails(common?.source?.state, name === LOCAL_RENTAL ? '' : common?.destination?.state),
            routeCountry            : RouteCountry,
            departureDate           : reviewResults?.start_time ? `${dateFormat(reviewResults?.start_time, dateTypeFormat)}` : `${dateFormat(common?.startDate?.date, dateTypeFormat)}`,
            departureTime           : reviewResults?.start_time ? `${dateFormat(reviewResults?.start_time, timeTypeFormat)}` : `${get24HoursTime(common?.startDate?.time)}`,
            cabsIsPrivateAvailable  :  "yes",
            bookingTags             : bookingTags,
            daysToTrip              : reviewResults?.start_time ? getTripDays(new Date().toString(), reviewResults?.start_time) : getTripDays(new Date().toString(), common?.startDate?.date)
          },
          account : getAccountInfo(),
          page    : getPageInfo({section: funnelSection,
            pageName: bookingReviewPageName,
            pageType: funnelPageType,
            flow,
            isSeoPage: false,
            loadedComponents : loadedComponent || "",
            ab_variant: reviewResults?.ab_variant,
          })
        }

        if (name === ROUND_TRIP) {
          eventDetails.booking["returnDate"] = reviewResults?.end_time ? `${dateFormat(reviewResults?.end_time, dateTypeFormat)}` : `${dateFormat(common?.endDate?.date || '', dateTypeFormat)}`
          eventDetails.booking["returnTime"] = reviewResults?.end_time ? `${dateFormat(reviewResults?.end_time, timeTypeFormat)}` : `${get24HoursTime(common?.endDate?.time || '')}`
          eventDetails.booking["duration"]   = reviewResults?.start_time && reviewResults?.end_time ? getTripDays(reviewResults?.start_time, reviewResults?.end_time) : getTripDays(common?.startDate?.date, common?.endDate?.date)
        }
        break;
      case gcRouteSEOScreen:
      case gcCitySEOScreen:
      case gcAirportCitySEOScreen:
      case gcRentalSEOScreen:
        const seoCommonData = seoPage?.results?.common_data || {};
        const seoPageTypeName = seoPage?.pageType === "route" ? seoRoutePageType  : seoPageType;
        const tripStartTime = `${dateFormat(common?.startDate?.date, 'yyyy-mm-dd')}T${get24HoursTime(common?.startDate?.time)}`
        eventDetails = {
          search  : {
            searchId                : seoCommonData?.dispatch_search_id || '',
            noOfSearchResults       : seoPage?.rental_data?.length > 0 ? seoPage?.rental_data?.length : 0,  
            alternateDateTimePopup  : Object.keys(seoCommonData)?.length && seoCommonData?.popup && Object.keys(seoCommonData?.popup)?.length ? "yes" : "no" 
          },
          booking: {
            tripType                : name,
            routeCity               : name === LOCAL_RENTAL ? getRouteDetails(common?.source?.name, '') : getRouteDetails(seoCommonData?.source_city, seoCommonData?.destination_city).length ? getRouteDetails(seoCommonData?.source_city, seoCommonData?.destination_city) : getRouteDetails(common?.source?.name, common?.destination?.name),
            routeState              : name === LOCAL_RENTAL ? getRouteDetails(common?.source?.state, '') : getRouteDetails(seoCommonData?.source?.state, seoCommonData?.destination?.state).length ? getRouteDetails(seoCommonData?.source?.state, seoCommonData?.destination?.state) : getRouteDetails(common?.source?.state, common?.destination?.state),
            routeCountry            : RouteCountry,
            departureDate           : `${dateFormat(common?.startDate?.date, dateTypeFormat)}`,
            departureTime           : `${get24HoursTime(common?.startDate?.time)}`,
            cabsIsPrivateAvailable  : seoPage?.rental_data?.length > 0 ? "yes" : "no",
            daysToTrip              : getTripDays(new Date().toString(), tripStartTime)
          },
          page    : getPageInfo({section: funnelSection, pageName: seoPage?.seoPageName, pageType: seoPageTypeName, flow, isSeoPage: true, loadedComponents : loadedComponent || ""}),
          account : getAccountInfo()
        }
        break;

      case gcHobLandingScreen:
        eventDetails = {
          page    : getPageInfo({section: homeSection, pageName: hobLandingPageName, pageType: homePageType, flow: hob?.source, isSeoPage: false, loadedComponents : loadedComponent || ""}),
          account : getAccountInfo()
        }
        break;

      case gcHobListingScreen:
        const searchIdArray = [];
        const suppliersArray = []
        hobListingResponse?.funnel_cab_card?.isMMTPreferred?.cards?.forEach((card) => {
          searchIdArray.push(card?.search_id);
          suppliersArray.push(card?.brand?.title);
        });
        hobListingResponse?.funnel_cab_card?.others?.cards?.forEach((card) => {
          searchIdArray.push(card?.search_id);
          suppliersArray.push(card?.brand?.title)
        });
        eventDetails = {
          search  : {
            searchId                : searchIdArray?.length ? searchIdArray.join(' | ') : "",
            noOfSearchResults       : suppliersArray?.length
          },
          productListItems: [{
            SKU : suppliersArray?.length ? suppliersArray.join('_') : ""
          }],
          booking: {
            tripType                : getTripTypeForHOB(hobListingResponse?.trip_type),
            routeCity               : hobListingResponse?.source_location?.address?.length ? hobListingResponse?.source_location?.address : "",
            routeState              : getRouteDetails(hobListingResponse?.source_location?.state, hobListingResponse?.destination_location?.state)?.length ? getRouteDetails(hobListingResponse?.source_location?.state, hobListingResponse?.destination_location?.state) : "",
            routeCountry            : RouteCountry,
            departureDate           : `${dateFormat(new Date(+hob?.pickupTime), dateTypeFormat)}`,
            departureTime           : `${dateFormat(new Date(+hob?.pickupTime), timeTypeFormat)}`,
            cabsIsPrivateAvailable  : suppliersArray?.length ? "yes" : "no",
            daysToTrip              : getTripDays(new Date().toString(), new Date(+hob?.pickupTime)?.toString()),
            bookingTags             : ""
          },
          page    : getPageInfo({section: homeSection, pageName: hobListingPageName, pageType: homePageType, flow: hob?.source, isSeoPage: false, loadedComponents : loadedComponent || ""}),
          account : getAccountInfo()
        }
        break;

      case gcHobThankyouScreen:
        eventDetails = {
          search  : {
            searchId                : "",
            noOfSearchResults       : ""
          },
          productListItems: [{
            SKU : hobThankYouResponse?.supplierDetails?.supplierName
          }],
          booking: {
            tripType                : getTripTypeForHOB(hobThankYouResponse?.tripType),
            routeCity               : hobThankYouResponse?.tripDetails?.pickupAddress?.secondaryText?.length ? hobThankYouResponse?.tripDetails?.pickupAddress?.secondaryText : "",
            routeState              : "",
            routeCountry            : RouteCountry,
            departureDate           : hobThankYouResponse?.tripDetails?.startTime ? `${dateFormat(new Date(+hobThankYouResponse?.tripDetails?.startTime), dateTypeFormat)}` : "",
            departureTime           : hobThankYouResponse?.tripDetails?.startTime ? `${dateFormat(new Date(+hobThankYouResponse?.tripDetails?.startTime), timeTypeFormat)}` : "",
            cabsIsPrivateAvailable  : "yes",
            daysToTrip              : getTripDays(new Date().toString(), new Date(+hobThankYouResponse?.tripDetails?.startTime)?.toString()),
            bookingId               : hobThankYouResponse?.tripDetails?.bookingId,
            paymentStatus           : "success",
            bookingTags             : ""
          },
          page    : getPageInfo({section: funnelSection, pageName: hobThankYouPageName, pageType: funnelPageType, flow: hobThankYouResponse?.flowName, isSeoPage: false, loadedComponents : loadedComponent || ""}),
          account : getAccountInfo()
        }
        break;
      default:
    }

    if (screenName !== gcHomeScreen || screenName !== gcHobLandingScreen || screenName !== gcHobListingScreen || screenName !== gcHobThankyouScreen) {
      if (name === LOCAL_RENTAL) {
        eventDetails.booking["packageId"] = package_id || common?.package_id
      }

      if (screenName !== gcBookingReviewScreen && name === ROUND_TRIP) {
        eventDetails.booking["returnDate"] = `${dateFormat(common?.endDate?.date || '', dateTypeFormat)}`
        eventDetails.booking["returnTime"] = `${get24HoursTime(common?.endDate?.time || '')}`
        eventDetails.booking["duration"]   = getTripDays(common?.startDate?.date || '', common?.endDate?.date)
      }
    }

    pushOmniEvents({eventName, details: eventDetails})
    loadedComponent = ""
  }
